import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ConsentRecord, ConsentRecordCreate, ConsentRecordFilter } from '../data/consentRecord';

export function createConsentRecordService(client: AxiosInstance) {
  return createCrudService<ConsentRecord, ConsentRecordCreate, ConsentRecordFilter>(
    client,
    '/audit/ConsentRecord',
    'id',
  );
}

export type ConsentRecordService = CrudService<ConsentRecord, ConsentRecordCreate, ConsentRecordFilter>;
